<script setup lang="ts">
import { ref, watch } from "vue"
import { vMaska } from "maska/vue"

const props = defineProps<{
  modelValue: string
  mask: any
  reversed: boolean
  [key: string]: any
}>()

const maskInputOptions = {
  mask: props.mask,
  reversed: props.reversed || false,
}

const emit = defineEmits(["update:modelValue"])
const inputValue = ref(props.modelValue)

watch(
  () => props.modelValue,
  (val) => {
    inputValue.value = val
  },
)

watch(
  () => props.mask,
  (val) => {
    maskInputOptions.mask = val
  },
)

watch(inputValue, (val) => {
  emit("update:modelValue", val)
})
</script>

<template>
  <VaInput v-bind="props" v-model="inputValue" v-maska="maskInputOptions" />
</template>
